import React, { useEffect, useState } from 'react';
import styles from './Cursor.module.css';

export default function Cursor() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [trailing, setTrailing] = useState({ x: -100, y: -100 });
  const [hovering, setHovering] = useState(false);

  useEffect(() => {
    const move = e => setPos({ x: e.clientX, y: e.clientY });
    window.addEventListener('mousemove', move);

    let rafId;
    let tx = -100, ty = -100;
    const animate = () => {
      tx += (pos.x - tx) * 0.12;
      ty += (pos.y - ty) * 0.12;
      setTrailing({ x: tx, y: ty });
      rafId = requestAnimationFrame(animate);
    };
    rafId = requestAnimationFrame(animate);

    const onEnter = e => {
      if (e.target.closest('a, button, [data-cursor]')) setHovering(true);
    };
    const onLeave = e => {
      if (e.target.closest('a, button, [data-cursor]')) setHovering(false);
    };

    window.addEventListener('mouseover', onEnter);
    window.addEventListener('mouseout', onLeave);

    return () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseover', onEnter);
      window.removeEventListener('mouseout', onLeave);
      cancelAnimationFrame(rafId);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pos.x, pos.y]);

  // Only show on desktop
  if (typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches) return null;

  return (
    <>
      <div
        className={`${styles.cursor} ${hovering ? styles.cursorHover : ''}`}
        style={{ left: pos.x, top: pos.y }}
      />
      <div
        className={styles.cursorTrail}
        style={{ left: trailing.x, top: trailing.y }}
      />
    </>
  );
}
